import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-box-packages',
  templateUrl: './icon-box-packages.component.html',
  styleUrls: ['./icon-box-packages.component.scss']
})
export class IconBoxPackagesComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit(): void {
  }

}
